export const deliveryFormats = [
    { value: '1', label: 'jpg' },
    { value: '2', label: 'jpeg' },
    { value: '3', label: 'png' },
    { value: '4', label: 'webp' },
    { value: '5', label: 'pdf' },
    { value: '6', label: 'doc' },
    { value: '7', label: 'docx' },
    { value: '8', label: 'ppt' },
    { value: '9', label: 'pptx' },
    { value: '10', label: 'xls' },
    { value: '11', label: 'xlsx' },
    { value: '12', label: 'csv' },
    { value: '13', label: 'svg' },
    { value: '14', label: 'gif' },
    { value: '15', label: 'html' },
    { value: '16', label: 'ics' },
    { value: "17", label: 'link' }
];